<template>
  <div v-if="tours.length > 0" class="booking-similar-tours">
    <div class="booking-similar-tours-title">
      {{ title }}
    </div>

    <BookingSimilarTour
      v-for="tour in tours"
      :key="tour.id"
      :tour="tour"
    />

    <div v-if="showCheckout" class="booking-similar-tours-footer">
      <div class="booking-similar-tours-footer-text">
        Ready to checkout?
      </div>

      <CustomButton
        text="Checkout now"
        variant="primary"
        icon="lock"
        @click="onCheckout"
      >
        <template #icon>
          <img
            :src="require('@/assets/icon/shopping-lock.svg')"
            alt="shopping-cart"
          >
        </template>
      </CustomButton>
    </div>
  </div>
</template>
<script>
import CustomButton from '@/components/utils/basic/CustomButton.vue'
import BookingSimilarTour from '@/components/containers/tour/BookingSimilarTour.vue'

export default {
  name: 'BookingSimilarTours',
  components: {
    CustomButton,
    BookingSimilarTour
  },
  props: {
    tours: {
      type: Array,
      require: true
    },
    title: {
      type: String,
      require: false,
      default: () => ''
    },
    showCheckout: {
      type: Boolean,
      require: false,
      default: () => false
    },
    onCheckout: {
      type: Function,
      require: false,
      default: () => () => {}
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.booking-similar-tours {
  padding: 24px 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: $text-white;
}

.custom-button {
  font-weight: 500 !important;
  font-size: 20px !important;
  line-height: 23px !important;
  letter-spacing: 0px !important;
}

.booking-similar-tours-title {
  @include font__title-1--regular();
  color: $blackberry;
}

.booking-similar-tours-footer-text {
  color: #68626C;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
}

.booking-similar-tours-footer {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
